import { mapActions, mapGetters, mapMutations } from "vuex";

import { email, maxLength, required } from "vuelidate/lib/validators";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import validation from "@/mixins/validation";

export default {
  name: "login",
  data() {
    return {
      payload: {
        email: this.$route.query.email ? this.$route.query.email : "",
        password: "",
      },
      validationErrors: {},
      showRecoverHint: false,
      showPassword: false,
      emailRules: {
        require: true,
      },
      passwordRules: {
        minLength: 8,
        require: true,
      },
      inputRefs: [],
    };
  },
  mixins: [validation],
  validations() {
    const payload = {
      email: {
        required,
        maxLength: maxLength(120),
      },
      password: {
        required,
        maxLength: maxLength(120),
      },
    }

    if (this.isValidEmail) {
      payload.email['email'] = email
    }

    return { payload };
  },
  computed: {
    ...mapGetters({
      loadingSingIn: "auth/loadingSingIn",
    }),
    isValidPhoneNumber() {
      if (!this.payload || !this.payload.email) {
        return false;
      }
      const cleaned = this.payload.email.trim().replace(/\D/g, '');
      const phoneRegex = /^\d{9,15}$/;
      return phoneRegex.test(cleaned.trim());
    },
    isValidEmail() {
      if (!this.payload || !this.payload.email) {
        return false;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.payload.email);
    },
    passwordErrors() {
      return this.computeErrors("payload", "password", {
        maxLength: { message: "validationMax", count: 120 },
        required: "validationRequired",
      });
    },
    emailErrors() {
      let validators = {
        maxLength: { message: "validationMax", count: 120 },
        required: "validationRequired",
      };

      if (this.isValidEmail) {
        validators = {
          ...validators,
          email: "validationEmail",
        }
      }

      return this.computeErrors("payload", "email", validators);
    },
  },
  created() {
    document.getElementById("html").classList.add("hide");
  },
  methods: {
    ...mapMutations({
      changeRegistrationPopup: "popups/CHANGE_REGISTRATION_POPUP",
      changeLoginPopup: "popups/CHANGE_LOGIN_POPUP",
      changeLoginManagerPopup: "popups/CHANGE_LOGIN_MANAGER_POPUP",
      changeRegisterAgentPopup: "auth/SHOW_AGENT_REGISTER_POPUP",
      changeResetPopup: "popups/CHANGE_RESET_POPUP",
    }),
    ...mapActions({
      login: "auth/GET_TOKEN",
      fetchUser: "profile/FETCH_USER_DATA",
      getFavorites: "favorites/GET_FAVORITES_LIST",
      fetchHeaderMenu: "setting/GET_HEADER_MENU",
    }),
    setItemRef(el) {
      if (el) {
        this.inputRefs.push(el);
      }
    },
    async submit() {
      this.validationErrors = {};
      this.showRecoverHint = false;

      this.$v.$touch();
      if (this.$v.$invalid) return;

      try {
        const localPayload = { ...this.payload };
        if (this.isValidPhoneNumber) {
          localPayload.email = this.toE164(this.payload.email);
        }
        await this.login(localPayload).then(() => {
          this.fetchUser().then(() => this.fetchHeaderMenu());
          this.getFavorites();
        });

        this.$toasted.success(this.$t("successLogin"));
        this.changeLoginPopup(false);

        this.$router.nav;

        fbq('track', 'sign_in');
        window.dataLayer.push({
          'event' : 'sign_in',
          'eventCategory' : 'sign_in',
          'eventAction' : 'sign_in',
          'loginMethod' : 'email'
        });
      } catch (error) {
        const data = error?.data;

        if (data?.errors) {
          // 422 з ключем errors — помилка валідації, показуємо під полем
          this.validationErrors = data.errors;
          return;
        }

        if (data?.message) {
          this.$toasted.error(data.message);
        }

        // 422 без errors — невірні дані / немає користувача / акаунт не активовано:
        // саме тут доречна пропозиція відновити пароль. На мережевій помилці
        // чи 500 вона недоречна, тому звіряємось зі статусом
        const status = error?.status;
        this.showRecoverHint = status === 401 || status === 422;
      }
    },
    toE164(value) {
      // у базі номери в E164, логін шукає точний збіг рядка
      const parsed = parsePhoneNumberFromString(String(value).trim(), "UA");
      return parsed && parsed.isValid() ? parsed.number : value;
    },
    goToReset() {
      this.changeResetPopup(true);
      this.changeLoginPopup(false);
    },
    changePopup() {
      this.changeRegistrationPopup(true);
      this.changeLoginPopup(false);
    },
  },
};
